var _defs, _path, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup3Marker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "iconn-office",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34,
    height: 54,
    viewBox: "0 0 34 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1536",
    "data-name": "Rectangle 1536",
    width: 18.286,
    height: 17.259,
    fill: "#1c6bcf"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_3",
    "data-name": "Union 3",
    d: "M-4148.595,5207.722a16.946,16.946,0,0,1-.981-1.9L-4150,5205h.089a16.96,16.96,0,0,1-1.089-6,17,17,0,0,1,17-17,17,17,0,0,1,17,17,16.96,16.96,0,0,1-1.089,6h.089l-.425.823a16.966,16.966,0,0,1-.978,1.895L-4134,5236Z",
    transform: "translate(4151 -5182)",
    fill: "#1c6bcf"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    transform: "translate(4 4)",
    fill: "#fff",
    stroke: "#6ca3e8",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12.5,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    "data-name": "Group 83",
    transform: "translate(7.857 8.37)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M35.792,55.3a4.55,4.55,0,1,1-4.586,4.55,4.568,4.568,0,0,1,4.586-4.55",
    transform: "translate(-26.601 -47.141)",
    fill: "#1c6bcf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M0,8.625l2.589,2.849L9.243,5.637,15.5,11.673l2.789-2.709L9.461,0Z",
    transform: "translate(0 0)",
    fill: "#1c6bcf"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3Marker);
export default __webpack_public_path__ + "static/media/group3-marker.20de3abf1da59d8410254d0fcdb501c1.svg";
export { ForwardRef as ReactComponent };